(function ($, Promise) {

	var HALF_PI = Math.PI / 2;

	// Setup the prototype inheritance
	extend(BaseGame, Portal);

	// Constructor
	function Portal() {

		// Super constructor
		BaseGame.call(this);
		this.resetDelay = 60 * 1000;
		// this.resetDelay = -1;

		// Override toolbar screen since we have a screensaver
		this.activateToolbarFrom = 1;

		this.selectedLevel = 0;
		this.shuffledRelatedLevels = [];
		this.currentShuffledExpertLevelIndex = -1;
		// this.touchEvent = "click";
		// this.touchEvent = "touchstart";

		// Variable to hold data
		this.data = {}
		this.currentGrid = [];
		this.draggable = false;
		this.ballTimeline = false;
		this.gameTimer = false;
		this.needMoreTimeTimeline = false;
		this.currentlyRotatingEl = false;
		this.currentMirror = false;

		// Orientations
		this.orientations = {
			"top": {angle: HALF_PI * -1, opposite: "bottom"},
			"right": {angle: 0, opposite: "left"},
			"bottom": {angle: HALF_PI * 1, opposite: "top"},
			"left": {angle: HALF_PI * 2, opposite: "right"},
		}

		// Load data then init
		this.loadData();

		// Resize window
		// var isNWJS = (typeof nw != "undefined") ? true : false;
		// if (isNWJS) {
		// 	var gui = require("nw.gui")
		// 	gui.Window.get().width = 1080;
		// 	gui.Window.get().height = 1920;
		// }
	}

	Portal.prototype.loadData = function () {

		// Load JSON
		var ajax1 = $.ajax({
			url: "data/puzzle.json",
			dataType: 'json',
			cache: false,
			complete: $.proxy(function (data) {
				this.data = JSON.parse(data.responseText);
			}, this)
		});

		// Load help content
		var ajax2 = $.ajax({
			url: "data/help.html",
			dataType: 'html',
			cache: false,
			complete: $.proxy(function (data) {
				this.help = $("<div>" + data.responseText + "</div>");
			}, this)
		});

		// Wait for all
		Promise.all([
			ajax1.promise(),
			ajax2.promise(),
		]).then($.proxy(function () {
			this.initGame();
		}, this));

	};

	Portal.prototype.initGame = function () {

		// Load SVGs
		convertSVGToInline();

		// Go to first element
		this.goToScreen(1);
		// this.i18n.set("en")
		// this.selectedLevel = 1;
		// this.goToScreen(4);
		// this.selectedLevel = 0;
		// this.launchBall();
		// this.showNeedMoreTimeModal();
		// this.goToScreen(5);

		// Bind keydown events
		$(window).on("keydown", $.proxy(function (e) {
			if (e.keyCode == 32) {
				// this.startEnigma();
				this.launchBall();
			}
		}, this));

		$(".custom-language-button").on(this.touchEvent, $.proxy(function (e) {
			var lang = $(e.currentTarget).data("lang");
			if (this.i18n.lang != lang) {
				this.i18n.flip();
			}
		}, this));

		$(document).on("i18nSet i18nFlip", $.proxy(function (e) {
			this.tutorialUpdateVideoSrc();
		}, this));

		$("#screen-1 .language-button").on(this.touchEvent, function (e) {
			$("#screen-1 .language-button").removeClass("active");
			$(e.currentTarget).addClass("active");
		});

		$("#screen-3 .tutorial").slick({
			dots: false,
			arrows: false,
			adaptiveHeight: false,
			infinite: false,
			speed: 600,
			slidesToShow: 1,
		}).on('afterChange', $.proxy(function (event, slick, direction) {
			if (this.currentScreen == 3) {
				this.tutorialUpdatePlayback();
			}
		}, this));

		// On rotate click
		$("#puzzle-grid, #puzzle-bank").on("mousedown touchstart", ".puzzle-element .puzzle-element-rotate", $.proxy(function (e) {
			e.preventDefault();
			e.stopImmediatePropagation()
			this.rotateStartEl(e);
		}, this));
		$(document).on("mousemove touchmove", $.proxy(function (e) {
			this.rotateUpdate(e);
		}, this));
		$(document).on("mouseup touchend", $.proxy(function (e) {
			this.rotateStop();
		}, this));

		// On rotate click
		$("#puzzle-launcher").on(this.touchEvent, $.proxy(function (e) {
			this.launchBall();
		}, this));

		// this.typeIn("x")

	};

	Portal.prototype.goToScreen = function (screenId, callback) {

		// Super constructor
		BaseGame.prototype.goToScreen.call(this, screenId, callback);

		// Play/pause video on tutorial slides
		this.tutorialUpdatePlayback(screenId);

		if (screenId == 1) {
			this.hideNeedMoreTimeModal();
			$("#screen-1 .language-button").removeClass("active");
		} else if (screenId == 3) {
			this.tutorialGoTo(0)
		} else if (screenId == 4) {
			this.initLevel(this.data.levels[this.selectedLevel]);
			$("#additional-ingame-buttons").fadeIn();
		} else if (screenId == 5) {
			$("#additional-ingame-buttons").fadeOut();
		}
	}

	Portal.prototype.selectRandomLevel = function () {

		// Create shuffled array with only expert levels
		if (this.shuffledRelatedLevels.length == 0) {
			for (var i = 0; i < this.data.levels.length; i++) {
				if (this.data.levels[i]["level-group"] == this.data.levels[this.selectedLevel]["level-group"] && i != this.selectedLevel) {
					// If it is the same levels group, add current data to shuffled array
					this.shuffledRelatedLevels.push(i);
				}
			}
			shuffle(this.shuffledRelatedLevels);
			this.shuffledRelatedLevels.push(this.selectedLevel)
		}

		// Increase random index
		this.currentShuffledExpertLevelIndex = (this.currentShuffledExpertLevelIndex + 1) % this.shuffledRelatedLevels.length;

		// Select new index
		this.selectedLevel = this.shuffledRelatedLevels[this.currentShuffledExpertLevelIndex];

		// Return newly selected index (even if useless)
		return this.selectedLevel;
	}

	Portal.prototype.selectLevel = function (level) {

		this.selectedLevel = (level) ? level : 0;

		// Update body class
		$("body").removeClass("apprentice expert ciphersleuth").addClass(this.currentLevelName());

		this.tutorialUpdateVideoSrc();

		this.goToScreen(3);
	}

	Portal.prototype.tutorialGoTo = function (id) {
		$("#screen-3 .tutorial").slick("slickGoTo", id);
		// this.tutorialUpdatePlayback();
	}

	Portal.prototype.tutorialUpdateVideoSrc = function () {

		console.log("tutorialUpdateVideoSrc", this.i18n.lang)

		if (this.i18n.lang == "fr") {
			$("#screen-3 ul.tutorial li").eq(0).find("video").attr("src", "videos/Step%201%20-%20FR.mp4");
			$("#screen-3 ul.tutorial li").eq(1).find("video").attr("src", "videos/Step%202%20-%20FR.mp4");
			if (this.isTimedLevel() == false) {
				$("#screen-3 ul.tutorial li").eq(2).find("video").attr("src", "videos/Step%203%20-%20FR%20-%20Apprentice.mp4");
			} else {
				$("#screen-3 ul.tutorial li").eq(2).find("video").attr("src", "videos/Step%203%20-%20FR%20-%20Expert.mp4");
			}
		} else {
			$("#screen-3 ul.tutorial li").eq(0).find("video").attr("src", "videos/Step%201%20-%20EN.mp4");
			$("#screen-3 ul.tutorial li").eq(1).find("video").attr("src", "videos/Step%202%20-%20EN.mp4");
			if (this.isTimedLevel() == false) {
				$("#screen-3 ul.tutorial li").eq(2).find("video").attr("src", "videos/Step%203%20-%20EN%20-%20Apprentice.mp4");
			} else {
				$("#screen-3 ul.tutorial li").eq(2).find("video").attr("src", "videos/Step%203%20-%20EN%20-%20Expert.mp4");
			}
		}

		this.tutorialUpdatePlayback();

	}

	Portal.prototype.tutorialUpdatePlayback = function (screenId) {

		// Define which screen id value to consider
		var screenId = (typeof screenId != "undefined") ? screenId : this.currentScreen;

		if (screenId == 2 || screenId == 3) {
			// On screen 3
			var currentSlide = $("#screen-3 .tutorial").slick("slickCurrentSlide");
			$("#screen-3 .tutorial li video").each(function (i, n) {
				if ($(n).attr("src") != "") {
					if (currentSlide == i) {
						n.currentTime = 0;
						n.play();
					} else {
						n.pause();
						n.currentTime = 0;
					}
				}
			});
		} else {
			// On other screen
			$("#screen-3 .tutorial li video").each(function (i, n) {
				if ($(n).attr("src") != "") {
					n.currentTime = 0;
					n.pause();
				}
			});
		}
	};

	Portal.prototype.initLevel = function (puzzleData) {

		console.log(puzzleData)

		// Dispose current level if any
		this.disposeLevel()
		this.isDragging = false;
		this.enableDrag();

		// Set layout (background) image
		$("#puzzle-layout").css("background-image", "url(" + puzzleData["layout-background"] + ")");

		// Set puzzle launcher position
		$("#puzzle-launcher").css({
			left: puzzleData["launcher-position"].x,
			top: puzzleData["launcher-position"].y,
		});

		// Hide ball
		$("#puzzle-ball").hide();

		// Add disabled to launch button
		$("#puzzle-launcher").toggleClass("disable", this.isLevelRequiringAllPieces());

		// Build grid
		for (var i = 0; i < puzzleData["grid-elements"].length; i++) {
			var elementInfo = this.decodeCode(puzzleData["grid-elements"][i]);
			if (elementInfo.type == "in" || elementInfo.type == "out") {
				var $el = this.createElement(elementInfo.color, elementInfo.type, elementInfo.orientation, false);
			} else if (elementInfo.type == "slot") {
				var $el = $("<div class='puzzle-slot'></div>")
			} else if (elementInfo.type == "target") {
				var $el = this.createElement(elementInfo.color, "insingle", elementInfo.orientation, false);
				$el.addClass("puzzle-target");
				$el.append("<div class='label'><div class='i18n fading-i18n'><span class='en'>Finish</span><span class='fr'>Arrivée</span></div></div>");
			} else {
				var $el = $("<div class='puzzle-spacer'></div>")
			}

			var $gridElement = $("<div class='grid-element'></div>").data("id", i);
			$gridElement.append($el);
			$("#puzzle-grid").append($gridElement);

			this.currentGrid.push(elementInfo);
		}

		// Apply flex settings to grid
		var ratioX = (100 / puzzleData["grid-count-x"]);
		var ratioY = (100 / puzzleData["grid-count-y"]);
		$("#puzzle-grid .grid-element").css({
			"flex-basis": ratioX + "%",
			"height": ratioY + "%"
		});

		// Set puzzle puzzle position
		$("#puzzle-bank").css({
			left: puzzleData["puzzle-bank-position"].x,
			top: puzzleData["puzzle-bank-position"].y,
		});

		// Set puzzle puzzle position
		$("#puzzle-bank .elements-wrapper").css({
			"margin-top": (puzzleData["puzzle-bank-element-height"] - $("#puzzle-grid .puzzle-element").first().height()) / 2
		});

		// Handle game timeout
		if (puzzleData["time-limit"] != 0) {

			// Show and set HTML element
			$("#puzzle-game-timer").show();
			$("#puzzle-game-timer span").text(parseInt(puzzleData["time-limit"]));

			// Start timer and related variables
			this.gameTimerCount = parseInt(puzzleData["time-limit"]);
			this.gameTimer = requestInterval($.proxy(function () {
				this.gameTimerCount = Math.max(0, this.gameTimerCount - 1);
				$("#puzzle-game-timer span").text(this.gameTimerCount);

				// Time up, stop timer
				if (this.gameTimerCount <= 0) {

					// Clear game timer interval
					if (this.gameTimer != false) {
						clearRequestInterval(this.gameTimer);
						this.gameTimer = false;
					}

					// Show popup
					this.showFeedback("timeout");
				}

			}, this), 1000);

		} else {
			$("#puzzle-game-timer").hide();
		}

		// Build puzzle element bank
		for (var i = 0; i < puzzleData["bank-elements"].length; i++) {
			var elementInfo = this.decodeCode(puzzleData["bank-elements"][i]);
			var $el = this.createElement(elementInfo.color, elementInfo.type, elementInfo.orientation, (elementInfo.type == "out"));
			$el.data("element-info", elementInfo);

			var $bankSlot = $("<div class='bank-slot'></div>")
			$bankSlot.css({
				width: $("#puzzle-grid .puzzle-element").first().width(),
				// height: $("#puzzle-grid .puzzle-element").first().width(),
				height: (typeof puzzleData["puzzle-bank-element-height"] != "undefined") ? puzzleData["puzzle-bank-element-height"] : $("#puzzle-grid .puzzle-element").first().width(),
			});
			$bankSlot.append($el);

			$("#puzzle-bank .elements-wrapper").append($bankSlot);
		}

		// This is a dirty trick to fix Shopify Draggable issue with double finger click
		$("#game-puzzle").off('touchstart').on('touchstart', '.puzzle-element.draggable', $.proxy(function (e) {
			if (this.isDragging) {
				console.log("stop")
				e.preventDefault()
				e.stopImmediatePropagation()
			}
			this.isDragging = true
		}, this)).on('touchend', '.puzzle-element.draggable', $.proxy(function (e) {
			this.isDragging = false;
		}, this));

		// Create draggable beahavior
		this.draggable = new Draggable.Draggable($("#game-puzzle").get(), {
			draggable: '.puzzle-element.draggable',
			handle: '.puzzle-element-top',
			delay: 10,
		});

		// Variable to hold initial position
		var clickOffset;

		// On drag start
		this.draggable.on('drag:start', $.proxy(function (evt) {

			console.log("drag")

			this.disableDrag();
			// this.isDragging = true

			// Make sure
			var initialLeft = (typeof evt.data.source.style.left == "undefined" || evt.data.source.style.left == "") ? 0 : parseInt(evt.data.source.style.left);
			var initialTop = (typeof evt.data.source.style.top == "undefined" || evt.data.source.style.top == "") ? 0 : parseInt(evt.data.source.style.top);

			// Define initial position values
			clickOffset = getPosition(evt.data.source);
			clickOffset.offsetX = evt.sensorEvent.clientX - (clickOffset.combinedX) - initialLeft;
			clickOffset.offsetY = evt.sensorEvent.clientY - (clickOffset.combinedY) - initialTop;

			// Save initial poisition once
			if (typeof $(evt.data.originalSource).data("initial-position") == "undefined") {
				$(evt.data.originalSource).data("initial-position", getPosition(evt.data.source))
			}

			// Release slot (if piece was using a slot)
			if (typeof $(evt.data.originalSource).data("slot") != "undefined" && $(evt.data.originalSource).data("slot") != false) {
				var sourceSlotId = $(evt.data.originalSource).data("slot");
				$(evt.data.originalSource).data("slot", false);
				this.currentGrid[sourceSlotId] = this.decodeCode("slot");
			}

			// Add transition effect on release (originalSource) and remove on grab (mirror)
			// evt.data.originalSource.style.transition = "transform 0.3s linear";;
			// evt.data.originalSource.style.transform = "";
			// console.log(evt.data.mirror, evt.mirror)
			// evt.data.mirror.style.transition = '';

		}, this));


		// On mirror created
		this.draggable.on('mirror:created', $.proxy(function (evt) {
			this.currentMirror = evt.data.mirror;
			this.currentMirror.style.transition = '';
		}, this));


		// On drag update
		this.draggable.on('drag:move', $.proxy(function (evt) {

			var coords = {
				x: evt.sensorEvent.data.clientX - clickOffset.offsetX - clickOffset.x,
				y: evt.sensorEvent.data.clientY - clickOffset.offsetY - clickOffset.y,
			}

			// evt.data.originalSource.style.transform = "translate3d(" + coords.x + "px, " + coords.y + "px, 0)";
			// evt.data.originalSource.style.transform = "";
			evt.data.originalSource.style.left = coords.x + "px";
			evt.data.originalSource.style.top = coords.y + "px";
			// // evt.data.originalSource.style.transition = "transform 0.3s linear";
			// evt.data.originalSource.style.transition = "top 0.3s linear, left 0.3s linear";

		}, this));

		// On drag stop
		this.draggable.on('drag:stop', $.proxy(function (evt) {

			this.isDragging = false;
			this.enableDrag();

			var droppedOnZone = this.zoneDroppedOn(this.currentMirror)
			var tranform_dest = {x: 0, y: 0};

			if (droppedOnZone && ($(".puzzle-slot", droppedOnZone).length > 0)) {

				// Deifne transformation to apply
				var droppendOnZoneCoords = getPosition($(droppedOnZone).find(".puzzle-element, .puzzle-slot").get(0));
				tranform_dest.x = droppendOnZoneCoords.x - $(evt.data.originalSource).data("initial-position").x;
				tranform_dest.y = droppendOnZoneCoords.y - $(evt.data.originalSource).data("initial-position").y;

				// Handle grid logic
				var droppedOnId = $(droppedOnZone).data("id")
				var draggedInfo = $(evt.data.originalSource).data("element-info");
				$(evt.data.originalSource).data("slot", droppedOnId);
				this.currentGrid[droppedOnId] = draggedInfo;
			}

			// Move to finale position
			requestAnimationFrame(function () {
				evt.originalSource.style.transition = " left 0.3s linear, top 0.3s linear";
				requestAnimationFrame(function () {
					// evt.originalSource.style.transform = "translate3d(" + tranform_dest.x + "px, " + tranform_dest.y + "px, 0)";
					// evt.originalSource.style.transform = "";
					evt.originalSource.style.left = tranform_dest.x + "px";
					evt.originalSource.style.top = tranform_dest.y + "px";


				});
			});

			if (this.isLevelRequiringAllPieces()) {
				requestTimeout($.proxy(function () {
					$("#puzzle-launcher").toggleClass("disable", !this.allPiecesUsed());
				}, this), 100);
			}

		}, this));

		this.enableDrag()
	}

	Portal.prototype.enableDrag = function () {
		$("#puzzle-bank .elements-wrapper .puzzle-element").addClass("draggable");
	}

	Portal.prototype.disableDrag = function () {
		$("#puzzle-bank .elements-wrapper .puzzle-element").removeClass("draggable");
	}

	Portal.prototype.decodeCode = function (code) {
		var elementCodes = code.split("-");
		var type = (elementCodes.length > 0) ? elementCodes[0] : false;
		var color = (elementCodes.length > 1) ? elementCodes[1] : false;
		var orientation = (elementCodes.length > 2) ? elementCodes[2] : false;
		return {
			type: type,
			color: color,
			orientation: orientation,
		}
	}

	Portal.prototype.zoneDroppedOn = function (el) {

		// Get dropped item position
		var itemPos = getPosition(el);

		// Loop through zones to find curent dropped on zone
		var selectedZone = false;
		var selectedZoneDist = 200;
		$("#puzzle-grid .grid-element").each(function (i, n) {
			var zonePosition = getPosition(n);
			var currentZoneDist = dist(itemPos.x, itemPos.y, zonePosition.x, zonePosition.y);

			if (currentZoneDist < selectedZoneDist) {
				selectedZone = n;
				selectedZoneDist = currentZoneDist;
			}
		});

		// Check if slot is available
		// 	if (zone && this.currentGrid[$(zone).data("id")].type != "slot") {
		if (selectedZone && this.currentGrid[$(selectedZone).data("id")].type != "slot") {
			return false;
		}

		return selectedZone;
	}

	Portal.prototype.createElement = function (color, mode, orientation, canRotate) {
		mode = (mode == "in" && orientation != false) ? "insingle" : mode;
		var $el = $("<div class='puzzle-element mode-" + mode + " color-" + color + " orientation-" + orientation + (canRotate ? " can-rotate" : "") + "'><div class='colorblind'></div><div class='transform-wrapper'><div class='puzzle-element-bottom'></div><div class='puzzle-element-top'></div><div class='puzzle-element-rotate'></div></div></div>")
		if (orientation) {
			$el.data("angle", this.orientations[orientation].angle)
		}
		return $el;
	}

	Portal.prototype.rotateStartEl = function (e) {

		// Stop if ball is already launched
		if (this.ballTimeline != false && this.ballTimeline.isActive()) {
			return;
		}

		// Disable drag
		this.disableDrag();

		// Save selected element
		this.currentlyRotatingEl = $(e.currentTarget).parents(".puzzle-element");

		// Define initial position values
		var currentPos = getPosition(this.currentlyRotatingEl.get(0));
		var elCenter = {
			x: currentPos.combinedX + this.currentlyRotatingEl.width() / 2,
			y: currentPos.combinedY + this.currentlyRotatingEl.height() / 2,
		}

		// Remove orientation class to
		this.currentlyRotatingEl.alterClass("orientation-*");

		// Save center to data
		this.currentlyRotatingEl.data("center", elCenter);

		// Request a rotate uodate
		this.rotateUpdate(e);
	}

	Portal.prototype.rotateUpdate = function (e) {

		if (this.currentlyRotatingEl == false) {
			return;
		}

		// Define cursor position depending on event type
		var cursorPos = {x: 0, y: 0};
		if (typeof e.touches != "undefined") {
			cursorPos = {
				x: e.touches[0].clientX,
				y: e.touches[0].clientY,
			};
		} else {
			cursorPos = {
				x: e.clientX,
				y: e.clientY,
			};
		}

		// Compute new angle
		var elCenter = this.currentlyRotatingEl.data("center");
		var angle = (Math.atan2(elCenter.y - cursorPos.y, elCenter.x - cursorPos.x)) % Math.PI;

		// Apply angle
		this.currentlyRotatingEl.data("angle", angle).find(".transform-wrapper").css({
			transform: "rotate(" + angle + "rad)",
		})
	}


	Portal.prototype.rotateStop = function () {

		if (this.currentlyRotatingEl == false) {
			return;
		}

		// Disable drag
		this.enableDrag();

		// Remove custum rotation
		this.currentlyRotatingEl.find(".transform-wrapper").css({
			transform: "none",
		});

		// // Define new class-based orientation
		var converted = Math.round(this.currentlyRotatingEl.data("angle") / (Math.PI / 2));
		var newOrientation = "bottom";
		if (Math.abs(converted) == 2) {
			newOrientation = "left"
		} else if (Math.abs(converted) == 0) {
			newOrientation = "right"
		} else if (converted == -1) {
			newOrientation = "top"
		} else {
			newOrientation = "bottom"
		}

		// Update values
		this.currentlyRotatingEl.alterClass("orientation-*", "orientation-" + newOrientation);
		if (typeof this.currentlyRotatingEl.data("element-info") != "undefined") {
			this.currentlyRotatingEl.data("element-info").orientation = newOrientation;
		} else {
			console.warn("Error in rotateStop (code 2), reverted to default orientation. Please have look.");
			this.currentlyRotatingEl.data("element-info").orientation = "left";
		}

		// Update logic grid
		if (this.currentlyRotatingEl.data("slot") && typeof this.currentlyRotatingEl.data("slot") != "undefined") {
			this.currentGrid[this.currentlyRotatingEl.data("slot")].orientation = newOrientation;
		} else {
			console.warn("Error in rotateStop (code 1). Please have look.");
		}

		// Unset dragged element
		this.currentlyRotatingEl = false;
	}

	Portal.prototype.launchBall = function () {

		// Stop if ball is already launched
		if (this.ballTimeline != false && this.ballTimeline.isActive()) {
			return;
		}

		// Check if all pieces are used
		if (this.isLevelRequiringAllPieces() == true && this.allPiecesUsed() == false) {
			console.log("Not all pieces used")
			this.showFeedback("not_all_used")
			return;
		}

		// Clear game timer interval
		if (this.gameTimer != false) {
			clearRequestInterval(this.gameTimer);
			this.gameTimer = false;
		}

		// Stop current rotation and disable drag
		this.rotateStop();
		this.disableDrag();

		// Get ball element
		var $ball = $("#puzzle-ball");

		// Show ball
		$ball.show();

		// Create timeline object
		this.ballTimeline = new TimelineMax();

		var previousTeleportationTargets = []
		var teleportationTarget = $("#screen-4 #puzzle-launcher");
		var teleportationCoord = this.getElementCoordinates(teleportationTarget);
		var throwTarget = {id: 0, orientation: "left"}
		var throwCoord = this.getElementCoordinates(throwTarget.id);

		// Initial launch
		this.ballTimeline.fromTo($ball, 0.5, {x: teleportationCoord.x, y: teleportationCoord.y}, {x: throwCoord.x, y: throwCoord.y});

		// While loop
		while (teleportationTarget != -1 && throwTarget != false && this.getOccurencesCount(teleportationTarget, previousTeleportationTargets) <= 2) {

			teleportationTarget = this.getTeleportationDestination(throwTarget);

			if (teleportationTarget != -1) {

				teleportationCoord = this.getElementCoordinates(teleportationTarget);
				throwTarget = this.getThrowDestination(teleportationTarget);

				// console.log(teleportationTarget, teleportationCoord, throwTarget)

				if (throwTarget == false) {

					throwCoord = {
						x: teleportationCoord.x,
						y: teleportationCoord.y
					};
					if (this.currentGrid[teleportationTarget].orientation == "right") {
						throwCoord.x += 158;
					} else if (this.currentGrid[teleportationTarget].orientation == "left") {
						throwCoord.x -= 158;
					} else if (this.currentGrid[teleportationTarget].orientation == "top") {
						throwCoord.y -= 158;
					} else if (this.currentGrid[teleportationTarget].orientation == "bottom") {
						throwCoord.y += 158;
					}

					// console.log("fake it out", this.currentGrid[teleportationTarget].orientation, teleportationCoord, throwCoord)

				} else {
					throwCoord = this.getElementCoordinates(throwTarget.id);
				}

				// Add translation animation
				this.ballTimeline.fromTo($ball, 0.5, {x: teleportationCoord.x, y: teleportationCoord.y}, {x: throwCoord.x, y: throwCoord.y});

				// Save target in array for upcoming comparaison
				previousTeleportationTargets.push(teleportationTarget);
			}
		}

		// Open resutling feedback modal
		if (teleportationTarget != -1 && this.getOccurencesCount(teleportationTarget, previousTeleportationTargets) > 2) {
			this.ballTimeline.call($.proxy(this.showFeedback, this), ["loop"], this, "+=0.00");
		} else if (throwTarget != false && this.currentGrid[throwTarget.id].type == "target") {
			// this.ballTimeline.call($.proxy(this.showFeedback, this), ["success"], this, "+=0.75");
			this.ballTimeline.call($.proxy(this.goToScreen, this), [5], this, "+=0.75");
		} else {
			this.ballTimeline.call($.proxy(this.showFeedback, this), ["fail"], this, "+=0.75");
		}
	}

	Portal.prototype.allPiecesUsed = function () {
		var allUsed = true;
		$("#puzzle-bank .puzzle-element").each(function (i, n) {
			if (typeof $(n).data("slot") == "undefined" || $(n).data("slot") == false) {
				allUsed = false;
			}
		});
		return allUsed;
	}

	Portal.prototype.showFeedback = function (option) {
		if (option == "loop") {
			this.showModal({
				title_fr: "Vous avez créé une boucle sans fin !",
				title_en: "You've created an endless loop!",
				content_fr: "<div class='apprentice-only'>Placez les pièces autrement.<br/><br/>Rappel : vous pouvez faire tourner l’une des pièces.</div><div class='expert-only'>Placez les pièces autrement.</div>",
				content_en: "<div class='apprentice-only'>Rearrange the pieces.<br/><br/>Don’t forget, one of them rotates.</div><div class='expert-only'>Rearrange the pieces.</div>",
			});
			$("#modal").alterClass("mode-*", "mode-warning");

		} else if (option == "fail") {
			this.showModal({
				title_fr: "Oups! La balle ne s’est pas rendue!",
				title_en: "Oops! The ball didn't make it!",
				content_fr: "<div class='apprentice-only'>Placez les pièces autrement.<br/><br/>Rappel : vous pouvez faire tourner l’une des pièces.</div><div class='expert-only'>Placez les pièces autrement.</div>",
				content_en: "<div class='apprentice-only'>Rearrange the pieces.<br/><br/>Don’t forget, one of them rotates.</div><div class='expert-only'>Rearrange the pieces.</div>",
			});
			$("#modal").alterClass("mode-*", "mode-error");

		} else if (option == "not_all_used") {
			this.showModal({
				title_fr: "Oups! Vous devez utiliser toutes les pièces.",
				title_en: "Oops! You need to use all the pieces.",
				content_fr: "<div class='apprentice-only'>Vous devez employer toutes les pièces de la réserve avant de tirer la balle.</div>",
				content_en: "<div class='apprentice-only'>You need to use all the pieces from the pieces bank in order to launch to ball.</div>",
			});
			$("#modal").alterClass("mode-*", "mode-not-all-used");

		} else if (option == "timeout") {
			this.showModal({
				title_fr: "Le temps est écoulé!",
				title_en: "Time's up!",
				content_fr: "<div class='apprentice-only'>Le temps est écoulé, et vous n’avez pas résolu le puzzle. Essayez de nouveau!</div>",
				content_en: "<div class='apprentice-only'>You did not solved the challenge within the allowed time. Try again!</div>",
			});
			$("#modal").alterClass("mode-*", "mode-timeout");

		} else if (option == "success") {
			// this.showModal({
			// 	title_fr: "Félicitations !",
			// 	title_en: "Congratulations!",
			// 	content_fr: "Vous avez résolu le défi !<br/>Il y a plusieurs solutions au défi, saurez-vous tous les trouver ?",
			// 	content_en: "You solved the puzzle.<br/>There is more than single way to solve the puzzle. Can you find them all?",
			// });
		}

		// Add expert mode class when there is a time limit
		// if (this.isTimedLevel()) {
		// 	$("#modal").addClass("mode-expert");
		// }

		// Add expert mode class when there is a time limit
		$("#modal").addClass("mode-" + this.currentLevelName());
	}

	Portal.prototype.showHelp = function (option) {
		this.showModal({
			title_fr: "Aide",
			title_en: "Instructions",
			content_fr: this.help.find(".fr").html(),
			content_en: this.help.find(".en").html(),
		});
		$("#modal").alterClass("mode-*", "mode-help");
	}


	Portal.prototype.getOccurencesCount = function (value, arr) {
		var count = 0;
		for (var i = 0; i < arr.length; i++) {
			var num = arr[i];
			if (num == value) {
				count++;
			}
		}
		return count;
	}

	Portal.prototype.getElementCoordinates = function (id) {

		var $el = (typeof id != "object") ? $("#puzzle-grid .grid-element").eq(id) : id;
		var coords = $el.offset();
		return {
			x: coords.left + ($el.width() / 2),
			y: coords.top + ($el.height() / 2),
		};
	}

	Portal.prototype.getTeleportationDestination = function (target) {
		var el1 = this.currentGrid[target.id];
		for (var i = 0; i < this.currentGrid.length; i++) {
			var el2 = this.currentGrid[i];

			if (el1.type != el2.type && el1.color == el2.color && ((el1.type == "in") && el2.type == "out")) {
				return i;
			}
		}
		return -1;
	}

	Portal.prototype.getThrowDestination = function (from) {
		var gridCountX = this.data.levels[this.selectedLevel]["grid-count-x"];
		var to = false;

		if (this.currentGrid[from].orientation == "right" && ((from + 1) < this.currentGrid.length)) {
			to = {
				id: from + 1,
				orientation: "right"
			};
		} else if (this.currentGrid[from].orientation == "left" && ((from - 1) >= Math.floor(from / gridCountX) * gridCountX)) {
			to = {
				id: from - 1,
				orientation: "left"
			};
		} else if (this.currentGrid[from].orientation == "top" && ((from - gridCountX) >= 0)) {
			to = {
				id: from - gridCountX,
				orientation: "top"
			};
		} else if (this.currentGrid[from].orientation == "bottom" && ((from + 1) < this.currentGrid.length)) {
			to = {
				id: from + gridCountX,
				orientation: "bottom"
			};
		}

		// Avoid ball from arriving from closed edge
		if (to && this.currentGrid[to.id].orientation != false) {
			if (this.currentGrid[to.id].orientation != this.orientations[this.currentGrid[from].orientation].opposite) {
				to = false;
			}
		}

		return to;
	}

	Portal.prototype.isTimedLevel = function () {
		return (typeof this.data.levels[this.selectedLevel]["time-limit"] != "undefined" && parseInt(this.data.levels[this.selectedLevel]["time-limit"]) > 0);
	}

	Portal.prototype.isLevelRequiringAllPieces = function () {
		return ((typeof this.data.levels[this.selectedLevel]["requires-all-pieces"] != "undefined") && (this.data.levels[this.selectedLevel]["requires-all-pieces"] == true));
	}

	Portal.prototype.currentLevelName = function () {
		return this.data.levels[this.selectedLevel]["level-group"];
	}

	Portal.prototype.resetLevel = function () {

		// Randomise level when there is a time limit (expert mode)
		if (this.isTimedLevel()) {
			this.selectRandomLevel();
		}

		this.initLevel(this.data.levels[this.selectedLevel]);
		this.hideModal();
	}

	Portal.prototype.backToGame = function () {
		this.hideModal();
		this.replaceBall();
	}

	Portal.prototype.restartGame = function () {
		if (this.isTimedLevel()) {
			this.selectRandomLevel();
		}
		this.goToScreen(4);
	}

	Portal.prototype.replaceBall = function () {
		var inititalBallPosition = this.getElementCoordinates($("#screen-4 #puzzle-launcher"));
		$("#screen-4 #puzzle-ball").css("transform", "translate(" + inititalBallPosition.x + "px," + inititalBallPosition.y + "px)");
		this.enableDrag();
	}

	Portal.prototype.toggleColorblind = function () {
		$("body").toggleClass("colorblind");
		$("#additional-ingame-buttons .button:eq(1)").toggleClass("active", $("body").hasClass("colorblind"));
	}


	Portal.prototype.disposeLevel = function () {

		// Destroy draggable object
		if (this.draggable) {
			this.draggable.destroy();
			this.draggable = false;
		}

		// Clear game timer interval
		if (this.gameTimer != false) {
			clearRequestInterval(this.gameTimer);
			this.gameTimer = false;
		}

		// Reset logic grid
		this.currentGrid = [];

		// Remove DOM elements
		$("#puzzle-bank .bank-slot").remove();
		$("#puzzle-grid .grid-element").remove();

		// Replace ball
		this.replaceBall();
	}

	Portal.prototype.stopCurrentAnimation = function () {

		// Stop current animation
		if (this.ballTimeline) {
			this.ballTimeline.progress(1).kill();
			this.ballTimeline = false;
		}
	}

	Portal.prototype.showNeedMoreTimeModal = function (params) {

		if (this.lockScreen || $("body").hasClass("need-more-time-modal")) {
			return;
		}

		// Add body class
		$("body").addClass("need-more-time-modal")

		// Create timeline object
		this.needMoreTimeTimeline = new TimelineMax();

		// Add translation animation
		this.needMoreTimeTimeline.fromTo($("#need-more-time-progress-fill"), 10, {
				width: "0%",
				ease: Linear.easeInOut,
			},
			{
				width: "100%",
				ease: Linear.easeInOut
			}
		);

		this.needMoreTimeTimeline.call($.proxy(this.hideNeedMoreTimeModal, this), [true], this);
	}

	Portal.prototype.hideNeedMoreTimeModal = function (needReset) {

		// Callback
		if (this.needMoreTimeTimeline) {
			this.needMoreTimeTimeline.kill();
			this.needMoreTimeTimeline = false;
		}

		if (needReset == true) {
			this.goToHome()
		}

		// Remove body class
		$("body").removeClass("need-more-time-modal")
	}

	Portal.prototype.goToHome = function () {
		this.reset(1)
	}

	Portal.prototype.goToScrenSaver = function () {

		console.log("goToScrenSaver")

		// Super constructor
		var shouldReset = BaseGame.prototype.shouldReset.call(this);

		if (shouldReset) {
			// this.reset(1);
			this.showNeedMoreTimeModal();
		}
	}

	Portal.prototype.reset = function (destinationScreen) {

		// Stop current animation
		this.stopCurrentAnimation();

		// Hide current modal if any
		this.hideModal();

		// Reset screen specific elements
		$("#screen-1 .language-button").removeClass("active");
		$("#additional-ingame-buttons").fadeOut();

		// Remove color blind mode
		$("body").removeClass("colorblind");
		$("#additional-ingame-buttons .button:eq(1)").removeClass("active", $("body").hasClass("colorblind"));

		// Define destination screen
		destinationScreen = destinationScreen || 1;

		// Go to screen
		this.goToScreen(destinationScreen, $.proxy(function () {
			$("#screen-3 .tutorial").slick("slickGoTo", 0);
			this.disposeLevel();
		}, this));
	}

// Expose Timeline
	window.Portal = Portal;

})
(jQuery, Promise);